// images
import roleMappingImage from './images/user-roles-mapping.jpg';
import companyInfoImage from './images/company.jpg';
import contactTypesImage from './images/contact-types.jpg';
import portsImage from './images/ports.jpg';
import carriersImage from './images/carriers.jpg';
import carrierTerminalsImage from './images/carrier-terminals.jpg';
import terminalsImage from './images/terminals.jpg';
import chasisPoolsImage from './images/chasis-pools.jpg';
import documentTypesImage from './images/document-types.jpg';
import creditTermsImage from './images/credit-terms.jpg';
import scacEmptyLocationsImage from './images/scac-empty-locations.jpg';
import assignImage from './images/assign_loads_img.png';
import weightRules from './images/weight-rules.jpg';
import marketDispatchSettings from './images/marketDispatchSettings.jpg';

const pages = [
  {
    text: 'Role Mapping',
    image: roleMappingImage,
    path: '/admin/users-role-mapping',
  },
  {
    text: 'Roles',
    image: assignImage,
    path: '/admin/roles',
  },
  {
    text: 'Company Info',
    image: companyInfoImage,
    path: '/admin/company-info',
  },
  {
    text: 'Contact Types',
    image: contactTypesImage,
    path: '/admin/contact-types',
  },
  {
    text: 'Ports',
    image: portsImage,
    path: '/admin/ports',
  },
  {
    text: 'Carriers',
    image: carriersImage,
    path: '/admin/carriers',
  },
  {
    text: 'Trace Terminals',
    image: carrierTerminalsImage,
    path: '/admin/trace-terminals',
  },
  {
    text: 'Markets',
    image: terminalsImage,
    path: '/admin/markets',
  },
  {
    text: 'Credit Terms',
    image: creditTermsImage,
    path: '/admin/credit-terms',
  },
  {
    text: 'Chassis Pools',
    image: chasisPoolsImage,
    path: '/admin/chassis-pools',
  },
  {
    text: 'Document Types',
    image: documentTypesImage,
    path: '/admin/document-types',
  },
  {
    text: 'Scheduled Tracing Table Maint',
    image: carrierTerminalsImage,
    path: '/admin/scheduled-tracing-table-maint',
  },
  {
    text: 'Scac Empty Locations',
    image: scacEmptyLocationsImage,
    path: '/admin/scac-empty-locations',
  },
  {
    text: 'Weight Rules',
    image: weightRules,
    path: '/admin/weight-rules',
  },
  {
    text: 'Market Dispatch Settings',
    image: marketDispatchSettings,
    path: '/admin/market-dispatch-settings',
  }
];

export default pages;
